import React from "react";
import { useNavigate } from "react-router-dom";

const SuccessScreen = () => {
  const navigate = useNavigate();
  return (
    <section id="screen-success" className="screen">
      {/* Celebration Effects */}
      <div className="celebration-container">
        <div
          className="firework"
          style={{ "--x": "15%", "--delay": "0s" }}
        ></div>
        <div
          className="firework"
          style={{ "--x": "50%", "--delay": "0.5s" }}
        ></div>
        <div
          className="firework"
          style={{ "--x": "85%", "--delay": "1s" }}
        ></div>
      </div>

      <div className="success-content">
        {/* Header */}
        <div className="success-header">
          <div className="floating-hearts-top">
            <span>💕</span>
            <span>💖</span>
            <span>💝</span>
            <span>💗</span>
            <span>💘</span>
          </div>

          <h1 className="success-title" style={{ font: "Great Vibes" }}>
            Yay! You said YES! 🎉
          </h1>
          <p className="success-message">
            I made all these gifts just for you, my love...
          </p>
        </div>

        {/* Gifts Grid */}
        <div className="gifts-grid">
          {/* Gift 1 */}
          <div className="gift-card" data-gift="teddy">
            <div className="gift-shine"></div>
            <div className="gift-icon">
              <svg viewBox="0 0 100 100">
                <circle cx="30" cy="35" r="12" fill="#8B4513" />
                <circle cx="70" cy="35" r="12" fill="#8B4513" />
                <ellipse cx="50" cy="55" rx="25" ry="28" fill="#A0522D" />
                <ellipse cx="50" cy="60" rx="15" ry="12" fill="#DEB887" />
                <circle cx="42" cy="50" r="3" fill="#333" />
                <circle cx="58" cy="50" r="3" fill="#333" />
                <ellipse cx="50" cy="58" rx="4" ry="3" fill="#333" />
                <path
                  d="M45 65Q50 70 55 65"
                  stroke="#333"
                  strokeWidth="2"
                  fill="none"
                />
                <circle cx="75" cy="70" r="10" fill="#DC143C" />
                <circle cx="75" cy="70" r="6" fill="#8B0000" />
                <rect x="73" y="78" width="4" height="15" fill="#228B22" />
              </svg>
            </div>
            <h3 className="gift-name">Teddy & Roses</h3>
            <p className="gift-desc">A cuddly friend with beautiful blooms</p>
            <div className="gift-hearts">💕 💖 💝</div>
            <button
              className="open-gift-btn"
              onClick={() => navigate("/teddy")}
            >
              Open Gift 💝
            </button>
          </div>

          {/* Gift 2 */}
          <div className="gift-card" data-gift="chocolate">
            <div className="gift-shine"></div>
            <div className="gift-icon">
              <svg viewBox="0 0 100 100">
                <rect
                  x="20"
                  y="40"
                  width="60"
                  height="35"
                  fill="#8B4513"
                  rx="3"
                />
                <rect
                  x="25"
                  y="45"
                  width="50"
                  height="25"
                  fill="#D2691E"
                  rx="2"
                />
                <rect x="28" y="48" width="12" height="8" fill="#3D1C02" />
                <rect x="44" y="48" width="12" height="8" fill="#654321" />
                <rect x="60" y="48" width="12" height="8" fill="#8B4513" />
                <rect x="28" y="58" width="12" height="8" fill="#A0522D" />
                <rect x="44" y="58" width="12" height="8" fill="#3D1C02" />
                <rect x="60" y="58" width="12" height="8" fill="#654321" />
                <path d="M35 40Q25 25 40 30Q50 35 35 40" fill="#FF1493" />
                <path d="M65 40Q75 25 60 30Q50 35 65 40" fill="#FF1493" />
                <circle cx="50" cy="38" r="4" fill="#FF69B4" />
                <text x="22" y="85" fontSize="6">
                  🍫
                </text>
                <text x="35" y="85" fontSize="6">
                  🍬
                </text>
                <text x="48" y="85" fontSize="6">
                  🍭
                </text>
                <text x="61" y="85" fontSize="6">
                  🧁
                </text>
                <text x="74" y="85" fontSize="6">
                  🍪
                </text>
              </svg>
            </div>
            <h3 className="gift-name">Sweet Delights</h3>
            <p className="gift-desc">Chocolates, candies & all things sweet</p>
            <div className="gift-hearts">🍫 🍬 🍭</div>
            <button
              className="open-gift-btn"
              onClick={() => navigate("/chocolate")}
            >
              Open Gift 💝
            </button>
          </div>

          {/* Gift 3 */}
          <div className="gift-card" data-gift="letter">
            <div className="gift-shine"></div>
            <div className="gift-icon">
              <svg viewBox="0 0 100 100">
                <rect
                  x="20"
                  y="20"
                  width="60"
                  height="50"
                  fill="#F5DEB3"
                  stroke="#8B7355"
                  strokeWidth="2"
                />
                <rect x="25" y="25" width="50" height="40" fill="#FFF8DC" />
                <path d="M50 20L20 70L80 70Z" fill="#DEB887" opacity="0.5" />
                <circle cx="70" cy="35" r="8" fill="#8B4513" opacity="0.3" />
                <circle cx="70" cy="35" r="5" fill="#8B4513" opacity="0.2" />
                <circle cx="50" cy="55" r="8" fill="#DC143C" />
                <text x="46" y="59" fontSize="10">
                  ❤️
                </text>
                <path d="M75 60L85 45" stroke="#333" strokeWidth="2" />
                <ellipse
                  cx="85"
                  cy="45"
                  rx="5"
                  ry="8"
                  fill="white"
                  transform="rotate(-30 85 45)"
                />
              </svg>
            </div>
            <h3 className="gift-name">Vintage Letter</h3>
            <p className="gift-desc">Words from my heart, aged with love</p>
            <div className="gift-hearts">📜 💌 ✨</div>
            <button
              className="open-gift-btn"
              onClick={() => navigate("/letter")}
            >
              Open Gift 💝
            </button>
          </div>

          {/* Gift 4 */}
          <div className="gift-card" data-gift="surprise">
            <div className="gift-shine"></div>
            <div className="gift-icon">
              <svg viewBox="0 0 100 100">
                <rect
                  x="25"
                  y="45"
                  width="50"
                  height="35"
                  fill="#9370DB"
                  rx="3"
                />
                <rect
                  x="25"
                  y="45"
                  width="50"
                  height="10"
                  fill="#8A2BE2"
                  rx="3"
                />
                <text x="45" y="75" fontSize="24" fill="#FFD700">
                  ?
                </text>
                <text x="20" y="40" fontSize="12">
                  ✨
                </text>
                <text x="70" y="40" fontSize="12">
                  ✨
                </text>
                <text x="15" y="70" fontSize="10">
                  ⭐
                </text>
                <text x="75" y="70" fontSize="10">
                  ⭐
                </text>
                <text x="35" y="35" fontSize="8">
                  💕
                </text>
                <text x="55" y="35" fontSize="8">
                  💖
                </text>
              </svg>
            </div>
            <h3 className="gift-name">Special Surprise</h3>
            <p className="gift-desc">Something magical just for you</p>
            <div className="gift-hearts">✨ 🎁 💫</div>
            <button
              className="open-gift-btn"
              onClick={() => navigate("/lovebook")}
            >
              Open Gift 💝
            </button>
          </div>
        </div>

        {/* Mailbox Decoration */}
        <div className="mailbox-decoration">
          <svg viewBox="0 0 80 100">
            <rect x="15" y="30" width="50" height="45" fill="#FF1493" rx="5" />
            <rect x="35" y="75" width="10" height="20" fill="#8B4513" />
            <rect x="10" y="70" width="60" height="8" fill="#8B4513" />
            <circle cx="50" cy="52" r="10" fill="white" />
            <rect x="46" y="48" width="8" height="8" fill="#FF1493" />
            <text x="45" y="25" fontSize="15">
              💌
            </text>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default SuccessScreen;
